// extracted by mini-css-extract-plugin
module.exports = {"featured":"_1ZuSldSQ","image":"HNCFlPom","title":"_2Vn5fKgC","meta":"_3iJcoDBx","summary":"_3a6dhWOy"};